import React from "react";
import img1 from "../../Assets/News&Blogs/image 1838.png";
import img2 from "../../Assets/News&Blogs/image 1833.png";
import img3 from "../../Assets/News&Blogs/image 1834.png";

const ProgressBar = ({ title, value, color }) => {
  return (
    <div className="mb-6">
      <div className="flex justify-between items-center mb-2">
        <span className="text-[#032303] font-medium text-lg">{title}</span>
        <span className="text-[#032303] font-bold text-lg">{value}</span>
      </div>
      <div className="w-full bg-gray-200 rounded-full h-2.5">
        <div
          className={`h-2.5 rounded-full ${color}`}
          style={{ width: `${value}` }}
        ></div>
      </div>
    </div>
  );
};

const ICVCertificationIndia = () => {
  return (
    <>
      <div className="w-full h-auto px-4 sm:px-10 grid grid-cols-1 xl:grid-cols-2 gap-8 bg-[#F7FAFF]">
        {/* left side */}
        <div className="w-full">
          {/* heading */}
          <div className="py-4 md:py-10">
            <div className="text-[#032303] font-bold sm:text-3xl md:font-medium text-lg md:text-4xl">
              <h1 className="">
                <span className="border-b-4 border-[#249742]"> ICV Ce</span>
                rtification India
              </h1>
            </div>
          </div>

          {/* content */}
          <div>
            <p className="font-normal text-lg text-[#4D4D4D]">
              ICV Certification India is Mumbai based consultancy firm working
              in the field of various ISO management system certification,
              process implementation services & company registration services.
              We specialize in providing various ISO, compliance certificates &
              company registration services at competitive rates.
            </p>

            {/* Progress Bars Section */}
            {/* <div className="mt-8">
              <ProgressBar
                title="ISO Certificates"
                value="95%"
                color="bg-[#29AAE1]"
              />
              <ProgressBar
                title="Compliance Certificates"
                value="80%"
                color="bg-[#29AAE1]"
              />
            </div> */}

            <p className="font-normal text-lg text-[#4D4D4D] py-2">
              ICV Certification India are unique, wherein we provide services
              from the beginning to the end and we assist our client to prepare
              quality policies and procedures to expedite obtaining an ISO /
              other quality certificates & company registration services. We are
              continuously improving our proven templates, which are customized
              to suit client's unique requirements. Moreover, tools, forms and
              other resources are constantly being developed and updated to
              ensure that our client receives the best possible service during
              in the quality standard implementation process.
            </p>
          </div>
        </div>

        {/* right side */}
        <div className="grid sm:grid-cols-2 grid-cols-1 gap-4">
          <div className="py-0 sm:py-8">
            <img
              src={img1}
              className="rounded-2xl w-full h-[500px] object-cover transition-transform duration-300 ease-in-out hover:scale-[1.02] hover:shadow-lg cursor-pointer"
              alt="Compliance certificate"
              loading="lazy"
            />
          </div>

          <div className="py-0 sm:py-8 flex flex-col gap-4">
            <div>
              <img
                src={img2}
                className="rounded-xl w-full h-[245px] object-cover transition-transform duration-300 ease-in-out hover:scale-[1.02] hover:shadow-lg cursor-pointer"
                alt="Compliance certificate"
                loading="lazy"
              />
            </div>
            <div>
              <img
                src={img3}
                className="rounded-xl w-full h-[245px] object-cover transition-transform duration-300 ease-in-out hover:scale-[1.02] hover:shadow-lg cursor-pointer"
                alt="Compliance certificate"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ICVCertificationIndia;
